import { render, staticRenderFns } from "./FormObserver.vue?vue&type=template&id=60890fc7&"
import script from "./FormObserver.vue?vue&type=script&lang=js&"
export * from "./FormObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports